import React, { useState } from "react";

import { Grid } from "@mui/material";
import { FormButton, SpinnerOverlay } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { RNHHorarioRangoDel } from "services/services-mia/programa-salud/personal/RNHHorarioRangoDel";

/**
 * Baja de un rango.
 *
 * Muestra lo mínimo para saber qué se está por borrar: de qué horario es y cuál es la
 * franja. No repite los días ni los campos de hora editables — el modal de baja no es
 * el de edición con los campos apagados, es una confirmación.
 *
 * La franja hace de "nombre": un rango no tiene uno propio cargado, así que para
 * reconocerlo se muestra su horario más su entrada y salida.
 */
export default function DeleteModal({ updateList, horarioRango, closeModal, onSuccess }) {
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);

    const handleSubmit = async () => {
        setInRequest(true);
        const respuesta = await RNHHorarioRangoDel(credentials, {
            id: horarioRango?.id,
            version: horarioRango?.version,
        });
        setInRequest(false);

        if (!respuesta.ok) return;

        setSnackbarInfo({
            message: "Rango horario eliminado correctamente",
            severity: "success",
            open: true,
        });
        updateList();
        onSuccess?.();
        closeModal();
    };

    const franja = [horarioRango?.entrada, horarioRango?.salida]
        .filter(Boolean)
        .join(" a ");

    return (
        <Formik
            initialValues={{
                horario: horarioRango?.horario ?? "",
                franja,
            }}
            onSubmit={handleSubmit}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <Grid
                        container
                        rowSpacing={0}
                        columnSpacing={2}
                        sx={{
                            width: "100%",
                            "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
                        }}
                    >
                        <Grid item xs={12}>
                            <FormikTextInput fullWidth name="horario" labelText="Horario" readOnly />
                        </Grid>
                        <Grid item xs={12}>
                            <FormikTextInput fullWidth name="franja" labelText="Rango" readOnly />
                        </Grid>
                    </Grid>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Eliminar" }}
                        onCloseModal={closeModal}
                    />
                    {inRequest && <SpinnerOverlay />}
                </div>
            </Form>
        </Formik>
    );
}
